"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenterBasics = exports.CenterBasicIcon = void 0;
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var styles_1 = require("@material-ui/core/styles");
var kinsideTokens_1 = require("../kinsideTokens");
var strings_1 = __importDefault(require("../strings"));
var core_1 = require("@material-ui/core");
var useStyles = styles_1.makeStyles(function (theme) {
    var _a, _b;
    return ({
        container: (_a = {
                border: "1px solid " + kinsideTokens_1.kinsideTokens['--gray-20'],
                padding: '20px 20px 0',
                borderLeftWidth: 0,
                borderRightWidth: 0
            },
            _a[theme.breakpoints.up('md')] = {
                borderRadius: 16,
                borderLeftWidth: 1,
                borderRightWidth: 1,
            },
            _a),
        icon: {
            fontSize: 18,
        },
        iconContainer: (_b = {
                width: 25,
                marginRight: 12,
                textAlign: 'center'
            },
            _b[theme.breakpoints.up('md')] = {
                width: 40,
                marginRight: 4,
            },
            _b),
        summaryText: {
            fontSize: 14,
        },
        basic: {
            display: 'flex',
        },
        clickable: {
            cursor: 'pointer',
            display: 'flex',
        },
    });
});
var mapBasicsToFaIcon = {
    CURRICULUM: pro_light_svg_icons_1.faShapes,
    LANGUAGE: pro_light_svg_icons_1.faLanguage,
    LANGUAGETAUGHT: pro_light_svg_icons_1.faEarthAmericas,
    ABILITIES: pro_light_svg_icons_1.faUniversalAccess,
    WHEELCHAIR: pro_light_svg_icons_1.faWheelchairMove,
    TRIBAL: pro_light_svg_icons_1.faPeopleRoof,
    VERIFIED: pro_light_svg_icons_1.faCircleCheck,
    DAY: pro_light_svg_icons_1.faCalendarWeek,
    TIME: pro_light_svg_icons_1.faClock,
    SCHEDULE: pro_light_svg_icons_1.faCalendarRange,
    CENTER: pro_light_svg_icons_1.faSchoolFlag,
    PAYMENT: pro_light_svg_icons_1.faDollarSign,
    CHILD: pro_light_svg_icons_1.faChildReaching,
    SUBSIDY: pro_light_svg_icons_1.faEnvelopeOpen,
};
var CenterBasicIcon = function (props) {
    var _a;
    var classes = useStyles(props);
    return (react_1.default.createElement("div", { className: classes.iconContainer }, ((_a = props.icon_url) === null || _a === void 0 ? void 0 : _a.length) && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: mapBasicsToFaIcon[props.icon_url], className: classes.icon }))));
};
exports.CenterBasicIcon = CenterBasicIcon;
var CenterBasics = function (props) {
    var _a;
    var classes = useStyles(props);
    if (!((_a = props.basics) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    var renderBasicBody = function (basic) {
        return (react_1.default.createElement("div", { onClick: basic.onClick, className: basic.onClick ? classes.clickable : classes.basic, style: { display: 'flex' } },
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(exports.CenterBasicIcon, { icon_url: basic.icon_url })),
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Typography_1.default, { className: classes.summaryText }, basic.value || basic.default_value))));
    };
    var renderBasic = function (basic, key) {
        var tooltip = basic.title || strings_1.default.basics[basic.icon_url.toLowerCase()];
        return (react_1.default.createElement(Grid_1.default, { item: true, xs: 6, key: key },
            react_1.default.createElement(Grid_1.default, { container: true, style: { flexWrap: 'nowrap', marginBottom: 16 } }, tooltip ? (react_1.default.createElement(core_1.Tooltip, { title: tooltip, placement: "top-start" }, renderBasicBody(basic))) : (renderBasicBody(basic)))));
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, direction: "row", className: classes.container }, props.basics.map(function (basic, i) {
        return (basic.value || basic.default_value) && renderBasic(basic, i);
    })));
};
exports.CenterBasics = CenterBasics;
